import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";
import ButtonGroup from "UI/ButtonGroup";
import Sizes from 'UI/sizes';

export default class TextStyle extends React.Component
{
    static propTypes = {
        value: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render()
    {
        return <ButtonGroup onChange={this.props.onChange}>
            <Button value="bold" active={this.props.value.includes('bold')} size={Sizes.EXTRA_SMALL}>
                <Bold />
            </Button>

            <Button value="italic" active={this.props.value.includes('italic')} size={Sizes.EXTRA_SMALL}>
                <Italic />
            </Button>

            <Button value="underline" active={this.props.value.includes('underline')} size={Sizes.EXTRA_SMALL}>
                <Underline />
            </Button>
        </ButtonGroup>;
    }
}

const Bold = () => <svg className='w-4' fill='currentColor' viewBox="0 0 299 299" xmlns="http://www.w3.org/2000/svg">
    <path d="M218 145c21-15 35-38 35-60 0-48-37-85-85-85H35v299h150c45 0 79-37 79-81 0-33-18-60-46-73zM99 53h64a32 32 0 110 64H99V53zm74 192H99v-64h74a32 32 0 110 64z"/>
</svg>;

const Italic = () => <svg className='w-4' fill='currentColor' viewBox="0 0 299 299" xmlns="http://www.w3.org/2000/svg">
    <path d="M107 0v64h47L81 235H21v64h171v-64h-47l73-171h59V0z"/>
</svg>;

const Underline = () => <svg className='w-4' fill='currentColor' viewBox="0 0 384 384" xmlns="http://www.w3.org/2000/svg">
    <path d="M192 299c71 0 128-58 128-128V0h-53v171a75 75 0 11-150 0V0H64v171c0 70 57 128 128 128zM43 341h299v43H43z"/>
</svg>;
